export default "__VITE_ASSET__0f3d3417__"